import { PhoenixTrpcClient } from 'apps/phoenix/src/app/utils';
import { Observable, from } from 'rxjs';

import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GeoService {
  phoenixTrpc = inject(PhoenixTrpcClient);

  parsePelias(address: string, results: number = 1): Observable<any> {
    return from(
      this.phoenixTrpc.pelias.search.query({ text: address, size: results })
    );
  }
}
